import {
    useMutation,
    useQuery,
    useQueryClient,
    UseQueryResult,
} from '@tanstack/react-query';
import { OrgChartHrMapping } from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/helpers/type';
import { resetGVTDataQueries } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/GVTData/helpers/hooks/gvtData';
import { RQAPICall } from 'store/APIClient';

export const useGetAllOrgChartHrMappings = (): UseQueryResult<
    OrgChartHrMapping[]
> => {
    const endpoint = 'human_resources/org_chart_hr_mapping';

    return useQuery({
        queryKey: ['org_chart_hr_mapping'],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};

/**
 * Hook to create a mapping
 */
export const usePostOrgChartHrMapping = () => {
    const endpoint = `human_resources/org_chart_hr_mapping`;

    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({
            title,
            orgChartHrSoftwareIds,
        }: {
            title: string;
            orgChartHrSoftwareIds: string[];
        }): Promise<unknown> =>
            RQAPICall({
                endpoint,
                method: 'PUT',
                body: { title, orgChartHrSoftwareIds },
            }),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['org_chart_hr_mapping'],
            });
            resetGVTDataQueries(queryClient);
        },
        meta: { useGlobalOnError: true },
    });
};
